export enum TruckType {
  Unknown = 0,
  LongTerm = 1,
  ShortTerm = 2,
  Substitute = 3,
  Owned = 4
}
export const TruckTypeMapping: Record<TruckType, string> = {
  [TruckType.Unknown]: 'Unknown',
  [TruckType.LongTerm]: 'Long Term',
  [TruckType.ShortTerm]: 'Short Term',
  [TruckType.Substitute]: 'Substitute',
  [TruckType.Owned]: 'Owned'
};
